"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../utils");

var StyledTag = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  var themeStyles = utils_1.getComponentThemeStyles(p.theme, 'Tag', p.variant, p.size);
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      align-items: center;\n      display: inline-flex;\n      justify-content: center;\n      whitespace: nowrap;\n\n      ", "\n    "], ["\n      align-items: center;\n      display: inline-flex;\n      justify-content: center;\n      whitespace: nowrap;\n\n      ", "\n    "])), themeStyles);
});
exports.Tag = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledTag, __assign({}, props, {
    ref: ref
  }), children);
});
exports.Tag.displayName = 'Tag';
var templateObject_1, templateObject_2;